import ErrorPage from 'pages/common/error';
import { Route, Routes } from 'react-router-dom';

import RoutesList from './constants';
import PaymentDetailPage from './details';
import PaymentLanding from './listing';

const PaymentRoutes = () => {
  return (
    <Routes>
      <Route index element={<PaymentLanding />} />
      <Route path={RoutesList.PAYMENT_LANDING} caseSensitive={true} element={<PaymentLanding />} />
      <Route path={`${RoutesList.PAYMENT_DETAILS}`} caseSensitive={true} element={<PaymentDetailPage />} />
      <Route
        path="*"
        element={<ErrorPage bodyTitle="Page Not Found" bodyText="The page you are trying to access doesn't exists" />}
      />
    </Routes>
  );
};

export default PaymentRoutes;
